// extracted by mini-css-extract-plugin
export default {"wrapper":"NtGWSAs2vwBVyNIQasxW","footer":"JFzMWJdY5b_x_6_JHP45","singleBtn":"XnTcRV_BXbW7CZSjOc1d","stretchHeight":"oZMFJe2GGTIwt1XtaArE","blockHeight":"J6eJZ9K0xXzFPKwwpnWO"};